import 'devextreme/ui/drop_down_box';
import Currency, { CurrencyProps } from './Currency';
import Image, { ImageProps } from './Image';
import RelatedItems, { RelatedItemsProps } from './RelatedItems';
import RelatedItemsCards, { RelatedItemsCardsProps } from './RelatedItemsCards';
import React from 'react';
import { EditorProps } from './EditorProps';

export type NuvoEditorTypeProps =
  | ImageProps
  | CurrencyProps
  | RelatedItemsProps
  | RelatedItemsCardsProps;

export type NuvoEditorType = NuvoEditorTypeProps['editorType'];

const editors = {
  Image,
  Currency,
  RelatedItems,
  RelatedItemsCards,
} satisfies Record<NuvoEditorType, React.NamedExoticComponent<EditorProps<any>>>;

export default editors;
